﻿window.CKEDITOR_BASEPATH = "../libs/ckeditor/";

// JScript File
window.rowOn = function (row, color) {
    var style = '#FFFFCC';
    if (color) {
        style = color;
    }
    var currentBackground = row.style.backgroundColor;
    if (currentBackground != style) {
        row.style.oldbg = currentBackground;
        row.style.backgroundColor = style;
    }
};

window.rowOut = function (row, color) {
    var oldBackground = row.style.oldbg;
    if (color != undefined && color != null) {
        oldBackground = color;
    }
    if (oldBackground != undefined && oldBackground != null) {
        row.style.backgroundColor = oldBackground;
    }
};

window.convertToJson = function (data) {
    var cache = [];
    var returnValue = JSON.stringify(data, function (key, value) {
        if (typeof value === 'object' && value !== null) {
            if (cache.indexOf(value) !== -1) {
                return;
            }
            cache.push(value);
        }
        return value;
    });

    return returnValue;
};

window.getHeight = function () {
    var myHeight = 0;
    if (typeof (window.innerWidth) == 'number') {
        //Non-IE
        myHeight = window.innerHeight;
    } else if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)) {
        //IE 6+ in 'standards compliant mode'
        myHeight = document.documentElement.clientHeight;
    } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
        //IE 4 compatible
        myHeight = document.body.clientHeight;
    }
    return myHeight;
};

window.getWidth = function () {
    var myWidth = 0;
    if (typeof (window.innerWidth) == 'number') {
        //Non-IE
        myWidth = window.innerWidth;
    } else if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)) {
        //IE 6+ in 'standards compliant mode'
        myWidth = document.documentElement.clientWidth;
    } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
        //IE 4 compatible
        myWidth = document.body.clientWidth;
    }
    return myWidth;
};

window.getElementByRel = function (_rel) {
    for (var z = 0; z < document.all.length; z++) {
        var obj = document.all[z];
        if (obj.rel == _rel)
            return obj;
    }
    return null;
};

window.IseBAControl = function (obj) {
    return typeof (obj) != 'undefined';
};

window.getBrowserNumberDecimalSeparator = function () {
    return (1 / 10).toString().charAt(1);
};

window.getBrowserNumberGroupSeparator = function () {
    return getBrowserNumberDecimalSeparator() == '.' ? ',' : '.';
};

window.convertNumberToString = function (number, numberDecimalSeparator, numberGroupSeparator, fractionDigits) {

    // check for missing parameters
    if (arguments.length == 0) {
        return '';
    }

    // check for missing parameters and use defaults if so
    if (arguments.length < 3 || numberGroupSeparator == undefined) {
        numberGroupSeparator = getBrowserNumberGroupSeparator();
    }
    if (arguments.length < 2 || numberDecimalSeparator == undefined) {
        numberDecimalSeparator = getBrowserNumberDecimalSeparator();
    }

    var num = new Number();

    if (typeof (number) == 'string') {
        num = convertStringToNumber(number, numberDecimalSeparator, numberGroupSeparator);
    }
    else if (typeof (number) == 'number') {
        num = number;
    }
    else {
        return '';
    }

    if (num == undefined || num == NaN || num.toString() == Number.NaN.toString()) {
        return '';
    }

    if (arguments.length == 4 && fractionDigits != undefined && typeof (fractionDigits) == 'number' && arguments != Number.NaN && arguments.toString() != Number.NaN.toString()) {
        var num2 = num.toFixed(fractionDigits);
        if (num != num2) {
            num = num2;
        }
    }

    // separate the whole number and the fraction if possible
    var arr = num.toString().split(getBrowserNumberDecimalSeparator());
    var decimalPart = (arr.length > 0 && arr[0] != null) ? arr[0].replace(getBrowserNumberGroupSeparator(), '') : '0'; // decimal
    var fractionPart = arr.length == 2 ? arr[1] : null; // fraction

    var sRegExp = new RegExp('(-?[0-9]+)([0-9]{3})');

    if (arguments.length >= 3 && numberGroupSeparator != undefined && numberGroupSeparator != null && numberGroupSeparator.length > 0) {
        while (sRegExp.test(decimalPart)) {
            decimalPart = decimalPart.replace(sRegExp, '$1' + numberGroupSeparator + '$2');
        }
    }

    //    if (fractionPart != null && fractionPart.length > 0) {
    //        fractionPart = fractionPart.replace(/0+$/, '');
    //    }

    return ((decimalPart == null || decimalPart.length == 0) ? '0' : decimalPart) + ((fractionPart != null && fractionPart.length > 0) ? (numberDecimalSeparator + fractionPart) : '');
};

window.convertStringToNumber = function (numberString, numberDecimalSeparator, numberGroupSeparator) {

    // check for missing parameters
    if (arguments.length == 0) {
        return Number.NaN;
    }

    if (typeof (numberString) == 'number') {
        return numberString;
    }
    else if (typeof (numberString) == 'string') {
        numberString = numberString.replace(/^\s+|\s+$/, '');
    }
    else {
        return Number.NaN;
    }

    // check for missing parameters and use defaults if so
    if (arguments.length < 3 || numberGroupSeparator == undefined) {
        numberGroupSeparator = getBrowserNumberGroupSeparator();
    }
    if (arguments.length < 2 || numberDecimalSeparator == undefined) {
        numberDecimalSeparator = getBrowserNumberDecimalSeparator();
    }

    var arr = numberString.split(numberDecimalSeparator);
    var decimalPart = (arr.length > 0 && arr[0] != null) ? arr[0] : '0'; // decimal
    var fractionPart = arr.length == 2 ? arr[1] : null; // fraction

    if (arguments.length >= 3 && numberGroupSeparator != undefined && numberGroupSeparator != null && numberGroupSeparator.length > 0) {
        while (decimalPart.indexOf(numberGroupSeparator) >= 0) {
            decimalPart = decimalPart.replace(numberGroupSeparator, '');
        }
    }

    numberString = decimalPart;
    if (fractionPart != null && fractionPart.length > 0)
        numberString += getBrowserNumberDecimalSeparator() + fractionPart;

    var number = new Number();
    number = parseFloat(numberString);

    return number;
};

window.ToNumber = function (numberString) {
    if (((typeof (numberString) == 'string') && (numberString.length == 0)) || numberString == '-')
        return 0;
    return convertStringToNumber(numberString, NumberDecimalSeparator, NumberGroupSeparator);
};

window.ToString = function (number, fractionDigits, useNumberGroupSeparator) {
    return convertNumberToString(number, NumberDecimalSeparator, useNumberGroupSeparator == true ? NumberGroupSeparator : "", fractionDigits);
};

window.filterNumeric = function (textBox, evt, allowFraction) {
    textBox.lastValue = textBox.value;
    evt = (evt) ? evt : ((window.event) ? event : null);
    if (evt) {
        var text = null;
        if (arguments.length == 1 && textBox != undefined && textBox != null) {
            text = textBox.value;
        }
        if (arguments.length < 3 || allowFraction == undefined || allowFraction == null) {
            allowFraction = true;
        }
        var charCode = (evt.charCode) ? evt.charCode :
            ((evt.keyCode) ? evt.keyCode :
            ((evt.which) ? evt.which : 0));

        var ch = String.fromCharCode(charCode);

        if (charCode < 32) {
            return true;
        }
        if ((charCode <= 57) && (charCode >= 48)) {
            if (!evt.shiftKey) {
                return;
            }
        }
        if ((ch == '-' && (text == undefined || text == null || text.indexOf(ch) < 0)) ||
            (allowFraction && ch == NumberDecimalSeparator && (text == undefined || text == null || text.indexOf(ch) < 0))) {
            return;
        }
        evt.returnValue = false;
        if (evt.preventDefault) evt.preventDefault();
        return false;
    }
};

window.formatNumeric = function (textBox, fractionDigits, useNumberGroupSeparator, editing) {
    if (editing && (ToNumber(textBox.value) == ToNumber(textBox.lastValue)))
        return;

    textBox.value = ToString(textBox.value, fractionDigits, useNumberGroupSeparator);

    textBox.lastValue = textBox.value;
};

window.getScrollPosition = function () {
    var x = 0;
    var y = 0;
    if (typeof (window.pageYOffset) == 'number') {
        x = window.pageXOffset;
        y = window.pageYOffset;
    }
    else if (document.documentElement && (document.documentElement.scrollLeft || document.documentElement.scrollTop)) {
        x = document.documentElement.scrollLeft;
        y = document.documentElement.scrollTop;
    }
    else if (document.body && (document.body.scrollLeft || document.body.scrollTop)) {
        x = document.body.scrollLeft;
        y = document.body.scrollTop;
    }
    var position = { 'x': x, 'y': y }
    return position;
};

window.saveScrollPositionToHidden = function (hiddenId) {
    if (hiddenId != undefined && hiddenId != null) {
        var hidden = document.getElementById(hiddenId);
        if (hidden != undefined && hidden != null) {
            try {
                var position = getScrollPosition();
                if (position != undefined && position != null) {
                    hidden.value = position.x.toString() + ',' + position.y.toString();
                }
            }
            catch (e) {
            }
        }
    }
};

window.setScrollPositionFromHidden = function (hiddenId) {
    if (hiddenId != undefined && hiddenId != null) {
        var hidden = document.getElementById(hiddenId);
        if (hidden != undefined && hidden != null) {
            try {
                if (hidden.value != null && hidden.value.length >= 3 && hidden.value.indexOf(',') > 0) {
                    var strs = hidden.value.split(',');
                    if (strs.length == 2) {
                        var x = parseInt(strs[0]);
                        var y = parseInt(strs[1]);
                        window.scrollTo(x, y);
                    }
                }
            }
            catch (e) {
            }
        }
    }
};

String.format = function () {
    var s = arguments[0];
    for (var i = 0; i < arguments.length - 1; i++) {
        var reg = new RegExp("\\{" + i + "\\}", "gm");
        s = s.replace(reg, arguments[i + 1]);
    }

    return s;
};

window.dimSum = function (jq, dims) {
    // Opera returns -1 for missing min/max width, turn into 0
    var sum = 0;
    for (var i = 1; i < arguments.length; i++)
        sum += Math.max(parseInt(jq.css(arguments[i])) || 0, 0);
    return sum;
};


window.GetDif = function () {
    var dif = 0;
    if (!topBannerVisible)
        dif = 74;

    if (!topBarVisible)
        dif = dif + 27;

    return dif;
};

window.waitSplitter = true;
window.waitingSplitter = false;
window.buttonsHeight2;
window.divId2;

window.setMainMenuDivHeight = function (buttonsHeight, divId) {
    var div = document.getElementById(divId);
    if (div != null) {
        var height = getHeight() - buttonsHeight - 108 + GetDif();
        if (height < 0) {
            height = 0;
        }
        //div.style.height = height;        // otipirdamaz - 21.09.2012 - document mode 9 olarak set edilince çalışmıyordu
        $(div).css({ height: height });      // otipirdamaz - 21.09.2012 
    }
};

window.cookiesEnabled = function () {
    if (JavaScriptCookies) {
        var ce = (navigator.cookieEnabled) ? true : false;

        if (ce) {
            document.cookie = "testcookie";
            ce = (document.cookie.indexOf("testcookie") != -1) ? true : false;
        }
        return ce;
    }
    else {
        return false;
    }
};


window.formatTime = function (event, textBox, hasSecond) {
    //var lengthLimit = hasSecond == true ? 8 : 5;

    //var selectionInfo = getSelectionCustom(textBox);

    //if (textBox.value.indexOf(":") == 1 && !((selectionInfo.selectionStart == 0 && selectionInfo.selectionEnd == 0) || (selectionInfo.selectionStart == 1 && selectionInfo.selectionEnd == 1))) {
    //    if (lengthLimit == 5) {
    //        lengthLimit = 4;
    //    }
    //    else if (lengthLimit == 8) {
    //        lengthLimit = 7;
    //    }
    //}

    //var correctSelection = true;
    //var selection = textBox.value.slice(selectionInfo.selectionStart, selectionInfo.selectionEnd);
    //if (selection.indexOf(":") > -1) {
    //    correctSelection = false;
    //    if ((selectionInfo.selectionStart == 0 && selectionInfo.selectionEnd == lengthLimit) || (selectionInfo.selectionStart == 3 && selectionInfo.selectionEnd == 8) || (lengthLimit == 7 && selectionInfo.selectionStart == 2 && selectionInfo.selectionEnd == 7) || (selectionInfo.selectionStart == 0 && selectionInfo.selectionEnd == lengthLimit)) {
    //        correctSelection = true;
    //    }
    //}

    //if ((((event.charCode >= 48 && event.charCode <= 58) || (event.keyCode >= 48 && event.keyCode <= 58)) && textBox.value.length < lengthLimit)
    //    || (event.keyCode == 8 && event.charCode != 8) || (event.keyCode == 46 && event.charCode != 46)
    //    || (((event.charCode >= 48 && event.charCode <= 58) || (event.keyCode >= 48 && event.keyCode <= 58)) && textBox.value.length == lengthLimit && selectionInfo.selectionStart != selectionInfo.selectionEnd && correctSelection)) {
    //    var lastChar;
    //    if ((event.keyCode == 58 || event.charCode == 58) &&
    //        !((selectionInfo.selectionStart == 1 && selectionInfo.selectionEnd == 1) || (selectionInfo.selectionStart == 2 && selectionInfo.selectionEnd == 2)
    //        || (selectionInfo.selectionStart == 4 && selectionInfo.selectionEnd == 4) || (selectionInfo.selectionStart == 5 && selectionInfo.selectionEnd == 5))) {
    //        event.keyCode = 0;
    //        if (event.preventDefault) event.preventDefault();
    //        else event.returnValue = false;
    //    }
    //    else {
    //        if (textBox.value.length > 0) {
    //            lastChar = textBox.value.substring(textBox.value.length - 1, textBox.value.length);
    //        }

    //        var lastCharDigit = lastChar != ':';

    //        if ((event.charCode == 58 || event.keyCode == 58) && (lastChar == ':')) {
    //            event.keyCode = 0;
    //            if (event.preventDefault) event.preventDefault();
    //            else event.returnValue = false;
    //        }
    //        else {
    //            if (hasSecond) {
    //                if (textBox.value.length == lengthLimit - 6) {
    //                    if (event.keyCode != 46 && event.keyCode != 8 && !(event.charCode == 58 || event.keyCode == 58) && lastCharDigit) {
    //                        textBox.value += ":";
    //                    }
    //                } else if (textBox.value.length == lengthLimit - 3) {
    //                    if (event.keyCode != 46 && event.keyCode != 8 && !(event.charCode == 58 || event.keyCode == 58) && lastCharDigit && hasSecond && textBox.value.indexOf(":") == textBox.value.lastIndexOf(":")) {
    //                        textBox.value += ":";
    //                    }
    //                }

    //                if (textBox.value.length >= lengthLimit && !correctSelection) {
    //                    event.keyCode = 0;
    //                }
    //            }
    //            else {
    //                if (textBox.value.length == lengthLimit - 3) {
    //                    if (event.keyCode != 46 && event.keyCode != 8 && !(event.charCode == 58 || event.keyCode == 58) && lastCharDigit && textBox.value.indexOf(":") < 0) {
    //                        textBox.value += ":";
    //                    }
    //                }

    //                if (textBox.value.length >= lengthLimit && !correctSelection) {
    //                    event.keyCode = 0;
    //                }
    //            }
    //        }
    //    }
    //}
    //else {
    //    if ((event.keyCode != 37 && event.keyCode != 39) || event.charCode == 37 || event.charCode == 39) {
    //        if (event.preventDefault) event.preventDefault();
    //        else event.returnValue = false;
    //    }
    //    event.keyCode = 0;
    // }

    var ss = getSelectionCustom(textBox).selectionStart;
    var chCode = event.charCode;
    if ((ss == 2) || (hasSecond && ss == 5)) {//: kısmında
        if (chCode != 0) {
            if (chCode != String.fromCharCode(":")) {
                if (timeControl(ss + 1, chCode, hasSecond)) {
                    textBox.value = textBox.value + ":" + String.fromCharCode(chCode);
                    event.preventDefault();
                } else {
                    textBox.value = textBox.value + ":";
                    event.preventDefault();
                }
            }
        }
    }
    else {
        if (!timeControl(ss, chCode, hasSecond)) {
            event.preventDefault();
        }
    }
};

window.timeAllTxtCntrl = function (event, textBox, hasSecond) {
    if (!hasSecond) {
        var re = /^\s*([01]?\d|2[0-3]):?([0-5]\d)\s*$/;
    } else {
        var re = /^\s*([01]?\d|2[0-3]):?([0-5]\d)\:?([0-5]\d)\s*$/;
    }
    if (!re.test(textBox.value)) {
        textBox.value = "";
    }
}

window.timeControl = function (ss, charCode, hasSecond) {
    if (!hasSecond) {
        var re = /^\s*([01]?\d|2[0-3]):?([0-5]\d)\s*$/;
        var formatTime = "00:00";
    } else {
        var re = /^\s*([01]?\d|2[0-3]):?([0-5]\d)\:?([0-5]\d)\s*$/;
        var formatTime = "00:00:00";
    }
    var tmpTime = "";
    if (charCode != 0) { //tek indexte işlem yapılıyorsa ve silme yapılmıyorsa
        tmpTime = formatTime.replaceAt(ss, String.fromCharCode(charCode));
        if (!re.test(tmpTime)) {
            return false;
        }
    }
    return true;
}

String.prototype.replaceAt = function (index, character) {
    return this.substr(0, index) + character + this.substr(index + character.length);
}
String.prototype.replaceGap = function (iStart, iEnd, character) { //başlangıç bitiş indexine kadar olan string yerine verilen karakteri koyar
    var nStr = "";
    for (var i = 0; i < this.length; i++) {
        if (iStart == i) {
            while (i != iEnd) {
                i++;
                if (i + 1 == iEnd) {
                    nStr += character;
                }
            }
        }
        nStr += this[i];
    }
}

window.getSelectionCustom = function (inputBox) {

    if (inputBox || inputBox == undefined) return;
    if ("selectionStart" in inputBox) {

        return {
            selectionStart: inputBox.selectionStart,
            selectionEnd: inputBox.selectionEnd
        }
    }

    //and now, the blinkered IE way
    var bookmark = document.selection.createRange().getBookmark()
    var selection = inputBox.createTextRange()
    selection.moveToBookmark(bookmark)

    var before = inputBox.createTextRange()
    before.collapse(true)
    before.setEndPoint("EndToStart", selection)

    var beforeLength = before.text.length
    var selLength = selection.text.length

    return {
        selectionStart: beforeLength,
        selectionEnd: beforeLength + selLength
    }
}

window.getDocumentForm = function (formID) {
    var f = null;

    if (formID != undefined && formID != null) {
        f = document.forms[formID];
    }

    if (f == undefined || f == null) {
        f = document.forms[0];
    }

    return f;
};

window.submitForm = function (formID) {
    var f = getDocumentForm(formID);

    if (f != null && f != undefined) {
        if (!f.onsubmit || f.onsubmit()) {  //checking onsubmit validations...       
            if (window.showLoading)
                window.showLoading();
            f.submit();
        }
    }
};

window.tifViewerPagesDropDownListChanged = function (dropDownListId, imageFrameId, pageLinksArray, index, previousPageLinkId, nextPageLinkId) {
    var dropDownList = document.getElementById(dropDownListId);
    var imageFrame = document.getElementById(imageFrameId);
    var previousPageLink = document.getElementById(previousPageLinkId);
    var nextPageLink = document.getElementById(nextPageLinkId);

    if (dropDownList.selectedIndex != index) {
        dropDownList.selectedIndex = index;
    }

    imageFrame.src = pageLinksArray[index];
    previousPageLink.disabled = index == 0 ? 'disabled' : '';
    nextPageLink.disabled = index < (pageLinksArray.length - 1) ? '' : 'disabled';

    if (index > 0) {
        previousPageLink.onclick = function () {
            dropDownList.selectedIndex = index - 1;
            tifViewerPagesDropDownListChanged(dropDownListId, imageFrameId, pageLinksArray, index - 1, previousPageLinkId, nextPageLinkId);
        };
    }
    if (index < pageLinksArray.length - 1) {
        nextPageLink.onclick = function () {
            dropDownList.selectedIndex = index + 1;
            tifViewerPagesDropDownListChanged(dropDownListId, imageFrameId, pageLinksArray, index + 1, previousPageLinkId, nextPageLinkId);
        };
    }
};

window.setImageSize = function (imgid, maxwidth) {
    var img = document.getElementById(imgid);
    //alert(imgid + " " + img.naturalWidth);
    if (img.clientWidth > maxwidth) {
        img.width = maxwidth;
    }
    img.style["visibility"] = "visible";
};

window.FormulaManagerValues = [];

window.InitializeFormulaCache = function () {
    FormulaManagerValues = [];
}

window.AddValueToFormulaCache = function (control) {
    FormulaManagerValues.push(control.value);
}

window.CalculateFormulaAvg = function () {
    if (FormulaManagerValues.length > 0) {
        var sum = 0;
        for (var i = 0; i < FormulaManagerValues.length; i++) {
            sum = sum + ToNumber(FormulaManagerValues[i]);
        }
        return sum / FormulaManagerValues.length;
    }
    else {
        return 0;
    }
}

window.CalculateFormulaMin = function () {
    return Math.min.apply(Math, FormulaManagerValues);
}

window.CalculateFormulaMax = function () {
    return Math.max.apply(Math, FormulaManagerValues);
}

window.CalculateFormulaCount = function () {
    return FormulaManagerValues.length;
}

window.CalculateFormulaStDev = function () {
    var avg = CalculateFormulaAvg();
    var retval = 0;
    var count = 0;

    for (var i = 0; i < FormulaManagerValues.length; i++) {
        var rv = ToNumber(FormulaManagerValues[i]);
        retval += Math.pow(rv - avg, 2);
        count++;
    }

    return ToNumber(Math.sqrt(ToNumber(Math.abs(retval / (count - 1)))));
}

window.loadGlobalize = function (userCulture) {
    Globalize.locale(userCulture);
}


//////////////////
// WEBPACK FOOTER
// ./libs/scripts.js
// module id = 389
// module chunks = 1 2